import { ContentIndexTypeEnum, IStaticContext, IStaticData } from "../dataType";

const data: Array<IStaticData> = [
  {
    content: [
      {
        text: "本利用規約（以下「本規約」といいます。）には、セーフィー株式会社（以下「当社」といいます。）の提供するサービスであるSafie Developersのご利用にあたり、Safie Developersユーザーの皆様に遵守していただかなければならない事項及び当社とSafie Developersユーザーの皆様との間の権利義務関係が定められております。当該サービスをSafie Developersユーザーとしてご利用になる方は、本規約に同意する前に、必ず全文お読みくださいますようお願い致します。",
      },
    ],
  },
  {
    title: {
      text: "第1条 適用",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "本規約は、Safie Developers（第2条に定義）の利用に関する当社とSafie Developersユーザー（第2条に定義）との間の権利義務関係を定めることを目的とし、Safie Developersユーザーと当社の間のSafie Developersの利用に関わる一切の関係に適用されます。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社が当社ウェブサイト（第2条に定義）上で随時掲載するSafie Developersに関するルール、諸規定等は本規約の一部を構成するものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "Safie Developersユーザーに適用されるSafie Developersに関するその他の規約、契約及びライセンス等や当社のパートナーまたは外部事業者の条件としてSafie Developersの利用に関する別段の定めがある場合、当該別段の定めが優先されるものとします。",
      },
    ],
  },
  {
    title: {
      text: "第2条 定義",
    },
    content: [
      {
        text: "本規約において使用する以下の用語は各々以下に定める意味を有するものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "「映像データ」とは、対応ハードウェアを利用して撮影された動画、静止画その他の映像データを意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "「外部サービス」とは、第16条第8項において定義される「外部サービス」を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "「外部事業者」とは、第16条第9項において定義される「外部事業者」を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(4)",
        styleObject: { marginLeft: "24px" },
        text: "「個人情報」とは、個人情報の保護に関する法律（平成15年法律第57号、以下「個人情報保護法」といいます）第2条第1項に定める個人情報を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(5)",
        styleObject: { marginLeft: "24px" },
        text: "「対応ハードウェア」とは、Safie Developers内機能群に対応するものとして当社が別途定めるネットワークカメラその他のハードウェアを意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(6)",
        styleObject: { marginLeft: "24px" },
        text: "「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(7)",
        styleObject: { marginLeft: "24px" },
        text: "「当社ウェブサイト」とは、そのドメインが「https://safie.link/」及び、「https://developers.safie.link/」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(8)",
        styleObject: { marginLeft: "24px" },
        text: "「利用希望者」とは、第4条において定義される「利用希望者」を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(9)",
        styleObject: { marginLeft: "24px" },
        text: "「利用者情報」とは、第4条において定義される「利用者情報」を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(10)",
        styleObject: { marginLeft: "24px" },
        text: "「Safie Developersユーザー」とは、第4条に基づき当社とSafie Developers利用契約を締結しSafie Developersを利用することができる個人又は法人を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(11)",
        styleObject: { marginLeft: "24px" },
        text: "「Safie Developers」（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）とは、当社が提供する「Safie PRO」という名称のクラウド型レコーディングサービス等（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。以下、「Safie PRO」といいます。）を通じて取得した映像データ等をSafie Developers内機能群として提供することで、Safie Developersユーザー及び映像データの利用を許可したユーザーが表示や解析に活用することができるサービスを意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(12)",
        styleObject: { marginLeft: "24px" },
        text: "「Safie Developers利用契約」とは、第4条第4項に定義される「Safie Developers利用契約」を意味します。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(13)",
        styleObject: { marginLeft: "24px" },
        text: "「Safie SDK(JavaScript)」とは、外部事業者が運用するWebサイトに組み込めるプログラムを提供するSafie Developers内機能群の一部です。",
      },
    ],
  },
  {
    title: {
      text: "第3条 サービス概要",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersの具体的内容は、当社ウェブサイト上の表示内容に準じます。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社は、Safie DevelopersユーザーがSafie Developers内機能群を介して連携するアプリケーション（以下「連携アプリケーション」といいます。）の設計、試験、開発、販売、使用、その他当社が別途許諾した行為を行うことを目的として、Safie Developersユーザーに対し、Safie Developers及びSafie Developers内機能群に関して提供される仕様書（以下「Safie Developers仕様書」といいます。）を非独占的に使用することを許諾します。但し、Safie Developersユーザーは、Safie Developers仕様書に記載された態様、用法に従ってSafie Developers及びSafie Developers内機能群を使用しなければならないものとします。",
      },
    ],
  },
  {
    title: {
      text: "第4条 利用登録",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersの利用を希望する者（以下「利用希望者」といいます。）は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「利用者情報」といいます。）をSafie Developersを通して当社に提供することにより、当社に対し、Safie Developersの利用登録をすることができます。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "前項の利用の登録は必ずSafie Developersを利用する個人又は法人自身が行わなければならず、当社が別途認めた場合を除き、代理人（法人の場合は法人の役員又は従業員等に該当しない、第三者たる代理人）による登録は認められません。また、利用希望者は登録にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "当社は、利用希望者が、以下の各号のいずれかの事由に該当する場合は、利用登録を削除することがあります。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "本規約に違反するおそれがあると当社が判断した場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "当社に提供された利用者情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "過去にSafie Developersの利用を取り消された者である場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(4)",
        styleObject: { marginLeft: "24px" },
        text: "反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(5)",
        styleObject: { marginLeft: "24px" },
        text: "Safie PROが提供されていない国に居住する場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(6)",
        styleObject: { marginLeft: "24px" },
        text: "その他、当社がSafie Developersの利用を適当でないと判断した場合",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "4.",
        text: "当社は、前項その他当社の基準に従って、利用希望者による利用の可否を判断し、当社が利用を認める場合にはその旨を利用希望者に通知します。かかる通知により、利用希望者と当社の間で本規約の諸規定に従ったSafie Developersの利用にかかる契約（以下「Safie Developers利用契約」といいます。）が成立し、利用希望者はSafie DevelopersユーザーとしてSafie Developersを利用することができます。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "5.",
        text: "Safie Developersユーザーは、利用者情報に変更があった場合は、遅滞なく、当該変更事項を当社に通知し、当社から要求された資料を提出するものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "6.",
        text: "Safie Developersユーザーは、Safie Developers利用契約又はSafie Developersの提供が終了するまで、本規約及び当社の定める方法に従い、Safie Developersを利用することができます。",
      },
    ],
  },
  {
    title: {
      text: "第5条 利用契約",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developers利用契約の有効期間は、以下のとおりとします。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "第4条1項に定める利用の申請において契約期間が定まっている場合には、当該契約期間に従います。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "第4条1項に定める利用の申請において契約期間が定まっていない場合には、第4条4項に基づくSafie Developers利用契約の成立日に効力を生じ、その1年後の日の属する月の末日までとします。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "前各号にかかわらず、事由を問わずSafie Developers利用契約が終了した場合又はSafie Developersの提供が終了した場合、当該日のいずれか早い日をもって、利用契約の有効期間は終了するとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "有効期間満了の1ヶ月前までに当社指定の方法に従い当社及びSafie Developersユーザーのいずれからも書面による更新拒絶又は契約条件変更等の申し出がない場合には、Safie Developers利用契約の有効期間は、同一の条件のもとに自動的に更新されるものとし、以降の期間についても同様とします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "Safie Developersユーザーは、Safie Developers利用契約の成立後、Safie Developers利用契約の有効期間中にSafie Developers利用契約を解約することはできないものとします。Safie Developersユーザーの都合によりSafie Developers利用契約の全部若しくは一部の解約が発生した場合又はSafie Developersユーザーの責任に帰する事由により当社によりSafie Developers利用契約が解除された場合には、Safie Developersユーザーは、当社に対し、解約料として、Safie Developers利用契約期間満了までのSafie Developersの利用料金を支払うものとします。",
      },
    ],
  },
  {
    title: {
      text: "第6条 料金及び支払方法",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersユーザーは、当社が別途定める場合には、Safie Developers内機能群の利用料金を支払うものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "前項の規定にかかわらず、Safie Developersユーザーが別途当社の定める代理店の仲介により当社との間でSafie Developers利用契約を締結した場合及びSafie Developersユーザーが別途当社の定める販売店からSafie Developers内機能群を購入した場合には、別途当社又は販売店との間で合意する利用料金を支払うものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "Safie Developersユーザーが利用料金の支払を遅滞した場合、Safie Developersユーザーは年14.6％の割合による遅延損害金を当社に支払うものとします。",
      },
    ],
  },
  {
    title: {
      text: "第7条 商標・商号等の利用",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersユーザーは、Safie Developers内機能群の使用または（連携）アプリケーションの制作およびこれに関するサービスの提供にあたり、当社が別途定める方法によって、当社の商標及び商号等（類似のものを含みます）を使用することができるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "Safie Developersユーザーは、当社が求める場合には、当社が別途定めるところにより、（連携）アプリケーションに表示されるサービスが当社によって提供されたものであることを表示 するものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "Safie SDK(JavaScript)にてWebサイトに組み込んだ際、同Webページ内に「Powered by Safie」を表示するものとします。この表示は「https://safie.co.jp」にリンクするものとします。",
      },
    ],
  },
  {
    title: {
      text: "第8条 禁止行為",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersユーザーは、Safie Developersの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "当社、又は他のSafie Developersユーザー、外部事業者その他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為（かかる侵害を直接又は間接に惹起する行為を含みます。）",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "対応ハードウェアを使用して、第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する内容の映像データを撮影する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する内容の映像データをSafie Developers内機能群を利用し送信する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(4)",
        styleObject: { marginLeft: "24px" },
        text: "犯罪行為に関連する行為又は公序良俗に反する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(5)",
        styleObject: { marginLeft: "24px" },
        text: "猥褻な情報又は青少年に有害な情報を送信する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(6)",
        styleObject: { marginLeft: "24px" },
        text: "法令又は当社若しくはSafie Developersユーザーが所属する業界団体の内部規則に違反する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(7)",
        styleObject: { marginLeft: "24px" },
        text: "コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(8)",
        styleObject: { marginLeft: "24px" },
        text: "Safie Developersに関し利用しうる情報を改ざんする行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(9)",
        styleObject: { marginLeft: "24px" },
        text: "当社が定める一定のデータ容量以上のデータをSafie Developers内機能群を利用して送信する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(10)",
        styleObject: { marginLeft: "24px" },
        text: "複数のユーザーIDを保有する行為及び1つのユーザーIDを複数人で共同して利用する行為（それらの準備を目的とした行為も含みます。）",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(11)",
        styleObject: { marginLeft: "24px" },
        text: "当社又は第三者になりすます行為（詐称するためにメールヘッダ等の部分に細工を行う行為を含みます。）",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(12)",
        styleObject: { marginLeft: "24px" },
        text: "Safie Developersのサーバ等のアクセス制御機能を解除又は回避するための情報、機器、ソフトウェア等を流通させる行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(13)",
        styleObject: { marginLeft: "24px" },
        text: "本人の同意を得ることなく、又は詐欺的な手段（いわゆるフィッシング及びこれに類する手段を含みます。）により第三者の情報を取得する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(14)",
        styleObject: { marginLeft: "24px" },
        text: "当社によるSafie Developersの運営を妨害するおそれのある行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(15)",
        styleObject: { marginLeft: "24px" },
        text: "Safie Developers内機能群に関する技術上の秘密を漏洩する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(16)",
        styleObject: { marginLeft: "24px" },
        text: "Safie Developers仕様書に記載した稼働環境下以外でSafie Developers内機能群を使用する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(17)",
        styleObject: { marginLeft: "24px" },
        text: "トライアルプランにて商業目的でSafie Developers内機能群を利用する行為",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(18)",
        styleObject: { marginLeft: "24px" },
        text: "その他、当社が不適切と判断する行為",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社は、Safie DevelopersにおけるSafie Developersユーザーによる情報の送信行為が前項各号のいずれかに該当し、又は該当するおそれがあると当社が判断した場合には、Safie Developersユーザーに事前に通知することなく、当該情報の全部又は一部を削除することができるものとします。当社は、本項に基づき当社が行った措置に基づきSafie Developersユーザーに生じた損害について、当社に故意又は重過失のある場合を除き、一切の責任を負いません。",
      },
    ],
  },
  {
    title: {
      text: "第9条 Safie Developers及びSafie Developers内機能群の停止等",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "当社は、以下のいずれかに該当する場合には、Safie Developersユーザーに事前に通知することなく、Safie Developer及びSafie Developers内機能群の利用の全部又は一部を停止又は中断することができるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "Safie Developers及びSafie Developers内機能群に係るコンピューター・システムの点検又は保守作業を定期的又は緊急に行う場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "コンピューター、通信回線等が事故により停止した場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "火災、停電、天災地変などの不可抗力によりSafie Developers及びSafie Developers内機能群の運営ができなくなった場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(4)",
        styleObject: { marginLeft: "24px" },
        text: "外部サービスに、トラブル、サービス提供の中断又は停止、Safie Developers及びSafie Developers内機能群との連携の停止、仕様変更等が生じた場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(5)",
        styleObject: { marginLeft: "24px" },
        text: "その他、当社が停止又は中断を必要と判断した場合",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社は、当社の都合により、Safie Developersユーザーに対して1ヶ月前に通知することにより、Safie Developersの提供を終了することができます。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "当社は、本条に基づき当社が行った措置に基づきSafie Developersユーザーに生じた損害について、当社に故意又は重過失のある場合を除き、一切の責任を負いません。",
      },
    ],
  },
  {
    title: {
      text: "第10条 対応ハードウェアその他の設備",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developers及びSafie Developers内機能群の提供を受けるために必要な、対応ハードウェア、スマートフォンその他の機器、通信回線その他の通信環境等の準備及び維持は、Safie Developersユーザーの費用と責任において行うものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "Safie Developersユーザーは自己のSafie Developers及びSafie Developers内機能群の利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。",
      },
    ],
  },
  {
    title: {
      text: "第11条 権利帰属",
    },
    content: [
      {
        text: "当社ウェブサイト及びSafie Developers及びSafie Developers内機能群に関する所有権及び知的財産権は全て当社又は当社にライセンスを許諾している者に帰属しており、本規約に定める登録に基づくSafie Developers及びSafie Developers内機能群の利用許諾は、当社ウェブサイト又はSafie Developers及びSafie Developers内機能群に関する当社又は当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。",
      },
      {
        text: "Safie Developersユーザーは、いかなる理由によっても当社又は当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これに限定されません。）をしないものとします。",
      },
    ],
  },
  {
    title: {
      text: "第12条 映像データ",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie DevelopersユーザーがSafie Developers内機能群を通じて送信した映像データの知的財産権は、Safie Developersユーザー又はSafie Developersユーザーに権利を許諾した者に帰属するものとします。但し、当社は、Safie DevelopersユーザーがSafie Developers内機能群を通じて送信した映像データを、Safie Developersを運営する目的で利用することができるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "Safie Developersユーザーは、当社に対し、Safie Developers内機能群を通じて送信した映像データについて、Safie Developersユーザーが当社に対して前項但書に基づく利用許諾をするために必要な知的財産権その他の権原及び権利を有することを表明し、かつ保証するものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "当社は、Safie Developersユーザーの事前の同意を得ずに、Safie DevelopersユーザーがSafie Developers内機能群を通じて送信した映像データを第三者に提供しないものとします。但し、次に定める場合には、当社は、Safie Developersユーザーの事前の同意を得ずに、映像データを第三者に提供することができるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "法令に基づく場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "人の生命、身体又は財産の保護のために必要がある場合であって、Safie Developersユーザーの同意を得ることが困難であるとき",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、Safie Developersユーザーの同意を得ることが困難であるとき",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(4)",
        styleObject: { marginLeft: "24px" },
        text: "国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、Safie Developersユーザーの同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(5)",
        styleObject: { marginLeft: "24px" },
        text: "当社がSafie Developersを運営するために必要な範囲内において映像データの取扱いの全部又は一部を委託する場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(6)",
        styleObject: { marginLeft: "24px" },
        text: "合併その他の事由による事業の承継に伴って映像データが提供される場合",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "4.",
        text: "Safie Developersユーザーは、当社がSafie Developersのサービスの内容として保存する場合を除き、当社にSafie DevelopersユーザーがSafie Developers内機能群を通じて送信した映像データを保存する義務がないことを認識し、了承するものとし、必要な場合にはSafie Developersユーザーの責任及び費用において映像データのバックアップをとるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "5.",
        text: "当社は、Safie DevelopersユーザーがSafie Developers内機能群を通じて送信した映像データを、Safie Developersの運営に必要な範囲で閲覧することができるものとし、第7条第1項その他の本規約の規定に違反しているものと判断した場合には、Safie Developersユーザーへの事前の通知なしに、当該映像データの全部又は一部を非公開又は削除することができるものとします。当社は、本項に基づき当社が行った措置に基づきSafie Developersユーザーに生じた損害について、当社に故意又は重過失のある場合を除き、一切の責任を負いません。",
      },
    ],
  },
  {
    title: {
      text: "第13条 個人情報",
    },
    content: [
      {
        text: "当社は、別途定める当社のプライバシーポリシーに従ってSafie Developersユーザーの個人情報を取り扱うものとし、Safie Developersユーザーは、当社のプライバシーポリシーに従って自己の個人情報が取り扱われることに同意するものとします。",
      },
    ],
  },
  {
    title: {
      text: "第14条 サービス提供",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "当社は、Safie Developersユーザーに対して、Safie Developers内機能群とは独立したサービスとして、開発中のサービスを提供することができるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社は、当社が必要と判断した場合には、Safie Developersユーザーに事前に通知をすることなくいつでも開発中のサービスの内容を変更し、又は開発中のサービスの提供を停止若しくは中止することができるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "当社は、開発中のサービスの特定の目的への適合性、商業的有用性、完全性、継続性等を含め、一切保証を致しません。",
      },
    ],
  },
  {
    title: {
      text: "第15条 解除等",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "当社は、Safie Developersユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該Safie DevelopersユーザーについてSafie Developers及びSafie Developers内機能群の利用を一時的に停止し、又は直ちにSafie Developers利用契約を解除することができます。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "本規約のいずれかの条項に違反した場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "利用者情報に虚偽の事実があることが判明した場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "当社、他のSafie Developersユーザー、外部事業者その他の第三者に損害を生じさせるおそれのある目的又は方法でSafie Developers内機能群を利用した、又は利用しようとした場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(4)",
        styleObject: { marginLeft: "24px" },
        text: "手段の如何を問わず、Safie Developersの運営を妨害した場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(5)",
        styleObject: { marginLeft: "24px" },
        text: "支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(6)",
        styleObject: { marginLeft: "24px" },
        text: "自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(7)",
        styleObject: { marginLeft: "24px" },
        text: "差押、仮差押、本規約に関する仮処分、強制執行又は競売の申立てがあった場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(8)",
        styleObject: { marginLeft: "24px" },
        text: "租税公課の滞納処分を受けた場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(9)",
        styleObject: { marginLeft: "24px" },
        text: "3ヶ月以上Safie Developersの利用がなく、当社からの連絡に対して応答がない場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(10)",
        styleObject: { marginLeft: "24px" },
        text: "第4条第3項各号に該当する場合",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(11)",
        styleObject: { marginLeft: "24px" },
        text: "その他、当社がSafie Developers利用契約の継続を適当でないと判断した場合",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "前項各号のいずれかの事由に該当した場合、Safie Developersユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "当社は、7日前までに当社所定の方法でSafie Developersユーザーに通知することにより、Safie Developers利用契約を解除することができます。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "4.",
        text: "当社は、本条に基づき当社が行った行為によりSafie Developersユーザーに生じた損害について、当社に故意又は重過失のある場合を除き、一切の責任を負いません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "5.",
        text: "解除、有効期間の満了その他理由の如何を問わずSafie Developers利用契約が終了した場合、Safie Developersユーザーは、当社の指示に基づき、当社から提供を受けたSafie Developers及びSafie Developers内機能群に関連するソフトウェア、マニュアルその他の物につき、返還、廃棄その他の処分を行うものとします。",
      },
    ],
  },
  {
    title: {
      text: "第16条 保証の否認及び免責",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersユーザーは、Safie Developersユーザー自身の自己責任においてSafie Developers及びSafie Developers内機能群を利用するものとし、Safie Developers及びSafie Developers内機能群を利用してなされた一切の行為及びその結果について、その責任を負うものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社は、Safie Developersを現状有姿で提供するものとし、Safie Developers及びSafie Developers内機能群の内容の追加、変更、又はSafie Developers及びSafie Developers内機能群の停止、終了によってSafie Developersユーザーに生じたいかなる損害についても、一切の責任を負いません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "当社は、Safie Developers及びSafie Developers内機能群の完全性、正確性、確実性、有用性、適法性、可用性等明示的か黙示的かに関わらず、いかなる種類の保証も行わないものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "4.",
        text: "当社は、Safie Developers及びSafie Developers内機能群へのアクセス過多、その他予期せぬ要因で表示速度の低下や障害等が生じた場合の責任を一切負わないものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "5.",
        text: "当社は、連携アプリケーション又は第三者サービス上（Safie Developersユーザー側のサーバー等含みます。）で発生した情報の漏えい等の責任について一切責任を負わないものとし、当社が、第三者から当該理由を原因として請求された場合、Safie Developersユーザーはその一切の費用を当社に補償するものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "6.",
        text: "当社は、Safie Developersユーザーによって登録される情報を監視、保存する義務を負わないものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "7.",
        text: "Safie Developersユーザーは、Safie Developers及びSafie Developers内機能群を利用して当社が映像データを保存又は配信する場合であっても、常時映像データを保存又は配信することができることを保証するものではなく、対応ハードウェアその他の Safie Developers内機能群の利用に供する装置、ソフトウェア又は通信網の瑕疵、障害、動作不良若しくは不具合その他の事由により、映像データを保存又は配信できない場合があることを認識し、了承するものとします。また、当社は、映像データを保存又は配信できなかったことによりSafie Developersユーザーに損害が生じた場合であっても、当社に故意又は重過失のある場合を除き、一切の責任を負わないものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "8.",
        text: "Safie Developers内機能群は、当社以外の第三者が提供するサービス（以下「外部サービス」といいます。）と連携することがありますが、かかる連携を保証するものではなく、 Safie Developers内機能群において外部サービスと連携できなかった場合でも、当社は一切の責任を負いません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "9.",
        text: "Safie Developers内機能群が外部サービスと連携している場合において、Safie Developersユーザーは当該外部サービスの規約を自己の費用と責任で遵守するものとし、Safie Developersユーザーと当該外部サービスを運営する第三者（以下「外部事業者」といいます。）との間で紛争等が生じた場合でも、当社は当該紛争等について一切の責任を負いません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "10.",
        text: "Safie Developersユーザーは、Safie Developers及びSafie Developers内機能群を利用することが、Safie Developersユーザーに適用のある法令、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、Safie DevelopersユーザーによるSafie Developers及びSafie Developers内機能群の利用が、Safie Developersユーザーに適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "11.",
        text: "Safie Developers及びSafie Developers内機能群又は当社ウェブサイトに関連してSafie Developersユーザーと他のSafie Developersユーザー、外部事業者その他の第三者との間において生じた取引、連絡、紛争等については、Safie Developersユーザーの責任において処理及び解決するものとし、当社はかかる事項について一切責任を負いません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "12.",
        text: "当社は、当社によるSafie Developersの提供の中断、停止、終了、利用不能又は変更、Safie Developersユーザーのメッセージ又は情報の削除又は消失､Safie Developersユーザーの登録の取消、Safie Developers内機能群の利用によるデータの消失又は機器の故障若しくは損傷、その他Safie Developers内機能群に関連してSafie Developersユーザーが被った損害につき、当社に故意又は重過失のある場合を除き、賠償する責任を一切負わないものとします",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "13.",
        text: "当社ウェブサイトから他のウェブサイトへのリンク又は他のウェブサイトから当社ウェブサイトへのリンクが提供されている場合でも、当社は、当社ウェブサイト以外のウェブサイト及びそこから得られる情報に関して如何なる理由に基づいても一切の責任を負わないものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "14.",
        text: "当社の賠償責任は、直接かつ通常の損害に限り、逸失利益、事業機会の喪失等の間接的な損害は含まないものとし、損害の事由が生じた時点から遡って過去3ヶ月間の期間にSafie Developersユーザーから現実に受領した利用料金の総額を上限とします。",
      },
    ],
  },
  {
    title: {
      text: "第17条 ユーザーの賠償等の責任",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersユーザーは、本規約に違反することにより、又はSafie Developers及びSafie Developers内機能群の利用に関連して当社に損害を与えた場合、当社に対しその損害を賠償しなければなりません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "Safie Developersユーザーが、Safie Developers及びSafie Developers内機能群に関連して他のSafie Developersユーザー、外部事業者その他の第三者からクレームを受け又はそれらの者との間で紛争を生じた場合には、直ちにその内容を当社に通知するとともに、Safie Developersユーザーの費用と責任において当該クレーム又は紛争を処理し、当社からの要請に基づき、その経過及び結果を当社に報告するものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "Safie DevelopersユーザーによるSafie Developersの利用に関連して、当社が、他のSafie Developersユーザー、外部事業者その他の第三者から権利侵害その他の理由により何らかの請求を受けた場合は、Safie Developersユーザーは当該請求に基づき当社が当該第三者に支払を余儀なくされた金額を賠償しなければなりません。",
      },
    ],
  },
  {
    title: {
      text: "第18条 本規約等の変更",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "当社は、Safie Developers及びSafie Developers内機能群の内容を自由に変更できるものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社は、本規約について､必要に応じて全部又は一部を変更する場合があります｡この際、変更がSafie Developersユーザーの一般の利益に適合し、又は、変更が、本規約の目的に反せず、変更の必要性及び変更後の内容の相当性が認められる場合には、あらかじめ、変更後の本規約及び効力発生時期（少なくとも2週間以上後）について、Safie Developersユーザーにメール等で周知することで本規約を変更するとします。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "3.",
        text: "本規約の変更が前項の要件を満たさない場合には、変更後の本規約の適用について、変更箇所を示した上で、再度、Safie Developersユーザーの個別の同意を得ることとします。",
      },
    ],
  },
  {
    title: {
      text: "第19条 秘密保持",
    },
    content: [
      {
        text: "Safie Developersユーザー及び当社は、相手方より提供を受けた技術上、営業上その他一切の情報（以下「秘密情報」といいます。）を秘密として取り扱うものとし、また本規約の目的以外に利用しないものとします。但し、次の各号のいずれかに該当する資料及び情報は秘密情報に含まれないものとします。",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(1)",
        styleObject: { marginLeft: "24px" },
        text: "既に公知のもの又は自己の責に帰すことのできない事由により公知となったもの",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(2)",
        styleObject: { marginLeft: "24px" },
        text: "既に保有しているもの",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(3)",
        styleObject: { marginLeft: "24px" },
        text: "守秘義務を負うことなく第三者から正当に入手したもの",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(4)",
        styleObject: { marginLeft: "24px" },
        text: "相手方から書面により開示を承諾されたもの",
      },
      {
        indexType: ContentIndexTypeEnum.brackets,
        indexText: "(5)",
        styleObject: { marginLeft: "24px" },
        text: "機密情報によらずに独自に開発し又は知り得たもの",
      },
    ],
  },
  {
    title: {
      text: "第20条 連絡/通知",
    },
    content: [
      {
        text: "Safie Developersに関する問い合わせその他Safie Developersユーザーから当社に対する連絡又は通知、及び本規約の変更に関する通知その他当社からSafie Developersユーザーに対する連絡又は通知は、当社の定める方法で行うものとします。",
      },
    ],
  },
  {
    title: {
      text: "第21条 権利義務の譲渡等",
    },
    content: [
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "1.",
        text: "Safie Developersユーザーは、当社の書面による事前の承諾なく、Safie Developers利用契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。",
      },
      {
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.",
        text: "当社はSafie Developersにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴いSafie Developers利用契約上の地位、本規約に基づく権利及び義務並びにSafie Developersユーザーの利用者情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、Safie Developersユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。",
      },
    ],
  },
  {
    title: {
      text: "第22条 完全合意",
    },
    content: [
      {
        text: "本規約は、本規約に含まれる事項に関する当社とSafie Developersユーザーとの完全な合意を構成し、口頭又は書面を問わず、本規約に含まれる事項に関する当社とSafie Developersユーザーとの事前の合意、表明及び了解に優先します。",
      },
    ],
  },
  {
    title: {
      text: "第23条 分離可能性",
    },
    content: [
      {
        text: "本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及びSafie Developersユーザーは、当該無効若しくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。",
      },
    ],
  },
  {
    title: {
      text: "第24条 存続規定",
    },
    content: [
      {
        text: "第6条（未払がある場合に限ります。）、第7条第2項、第8条第2項、第10条、第11条、第12条、第13条、第14条第2項、第4項及び第5項、第15条、第16条まで、並びに第20条から第24条までの規定はSafie Developers利用契約の終了後も有効に存続するものとします。",
      },
    ],
  },
  {
    title: {
      text: "第25条 準拠法及び管轄裁判所",
    },
    content: [
      {
        text: "本規約の準拠法は日本法とし、本規約に起因し又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。",
      },
    ],
  },
  {
    title: {
      text: "第26条 協議解決",
    },
    content: [
      {
        text: "当社及びSafie Developersユーザーは、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。",
      },
    ],
  },
  {
    content: [
      {
        styleObject: { marginTop: "80px" },
        text: "【2023年1月12日制定】",
      },
      {
        text: "【2023年7月13日改訂】",
      },
      {
        text: "【2023年9月7日改訂】",
      },
      {
        text: "【2025年1月27日改訂】",
      },
    ],
  },
];

const context: IStaticContext = {
  headerTitle: "Safie Developers利用規約",
  headerIcon: require("./images/header-icon.svg"),
  data: data,
};

export default context;
